import React from 'react'
import { Theme, withStyles } from '@material-ui/core/styles'
import Dialog from '@material-ui/core/Dialog'
import MuiDialogContent from '@material-ui/core/DialogContent'
import MuiDialogActions from '@material-ui/core/DialogActions'
import { Grid, makeStyles } from '@material-ui/core'
import { isMobile } from 'react-device-detect'
import close from '../assets/images/colosePopup.svg'

const DialogContent = withStyles((theme: Theme) => ({
  root: {
    padding: 0,
  },
}))(MuiDialogContent)

const DialogActions = withStyles((theme: Theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(1),
  },
}))(MuiDialogActions)

interface ChartTooltipModalProps {
  open?: any
  setOpen?: any
  handleClose?: any
  tooltipInfo?: any
}
const useStyles = makeStyles({
  content: {
    background: '#FFFFFF',
    boxSizing: 'border-box',
    borderRadius: 3,
    maxWidth: 820,
    width: '100%',
    maxHeight: '80vh',
    display: 'flex',
    flexDirection: 'column',
    padding: '4px 24px 24px 24px',
  },
  title: {
    color: '#181818',
    fontFamily: 'Inter, sans-serif',
    fontSize: 24,
    lineHeight: '28px',
    fontWeight: 600,
  },
  closeBtn: {
    width: 36,
    height: 36,
    borderRadius: 999,
    background: '#F2F2F2',
    boxSizing: 'border-box',
  },
  subTitle: {
    fontFamily: 'Inter, sans-serif',
    fontSize: 24,
    lineHeight: '28px',
    color: '#5E5E5E',
    fontWeight: 400,
  },
  detailContent: {
    marginBottom: 12,
  },
  header: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    paddingBottom: 12,
    marginBottom: 16,
    borderBottom: '1px solid #DFE4EB',
    '& input': {
      width: 36,
      height: 36,
      borderRadius: 999,
      background: '#F2F2F2',
      boxSizing: 'border-box',
    },
  },
  mobileHeader: {
    display: 'grid',
    gridTemplateColumns: '1fr auto',
    columnGap: 12,
    alignItems: 'start',
    width: '100%',
  },
  mobileTitle: {
    minWidth: 0,
    paddingRight: 8,
  },
  mobileSubTitle: {
    display: 'block',
    marginTop: 4,
    fontSize: 20,
    lineHeight: '24px',
  },
  body: {
    overflowY: 'auto',
    paddingRight: 4,
  },
  typeHead: {
    fontFamily: 'Inter, sans-serif',
    fontSize: 14,
    lineHeight: '22px',
    fontWeight: 700,
    color: '#1B3963',
  },
  typeDetail: {
    fontFamily: 'Inter, sans-serif',
    fontWeight: 500,
    fontSize: 14,
    lineHeight: '22px',
    color: '#475569',
    '& b': {
      fontWeight: 700,
      color: '#1B3963',
    },
  },
})

const ChartTooltipModal = ({
  open,
  setOpen,
  handleClose,
  tooltipInfo,
}: ChartTooltipModalProps) => {
  const classes = useStyles()
  return (
    <div>
      <Dialog
        onClose={handleClose}
        aria-labelledby="customized-dialog-title"
        open={open}
        maxWidth={false}
        PaperProps={{ style: { maxWidth: 820, width: '100%' } }}
      >
        <DialogContent>
          <div className={classes.content}>
            {isMobile && (
              <div className={classes.header}>
                <div className={classes.mobileHeader}>
                  <div className={classes.mobileTitle}>
                    <div className={classes.title}>{tooltipInfo.title}</div>
                    {tooltipInfo.subTitle && (
                      <div
                        className={`${classes.subTitle} ${classes.mobileSubTitle}`}
                      >
                        ({tooltipInfo.subTitle})
                      </div>
                    )}
                  </div>
                  <input
                    className={classes.closeBtn}
                    type="image"
                    onClick={() => handleClose()}
                    src={close}
                    alt="closeBtn"
                  />
                </div>
              </div>
            )}

            {!isMobile && (
              <div className={classes.header}>
                <div>
                  <span className={classes.title}>{tooltipInfo.title}</span>
                  {tooltipInfo.subTitle && (
                    <span className={classes.subTitle}>
                      {' '}
                      ({tooltipInfo.subTitle})
                    </span>
                  )}
                </div>
                <input
                  type="image"
                  onClick={() => handleClose()}
                  src={close}
                  alt="closeBtn"
                />
              </div>
            )}
            <div className={classes.body}>
              <div className={classes.detailContent}>
                <span className={classes.typeHead}>What it shows: </span>
                <span className={classes.typeDetail}>
                  {tooltipInfo.whatToShow}
                </span>
              </div>

              {tooltipInfo.purpose && (
                <div className={classes.detailContent}>
                  <span className={classes.typeHead}>Purpose of chart: </span>
                  <span className={classes.typeDetail}>
                    {tooltipInfo.purpose}
                  </span>
                </div>
              )}
              <div className={classes.detailContent}>
                <span className={classes.typeHead}>
                  Things to look out for:{' '}
                </span>
                <span className={classes.typeDetail}>
                  {tooltipInfo.thingsToLookOutFor}
                </span>
              </div>
              <div className={classes.detailContent}>
                <span className={classes.typeHead}>Next best action: </span>
                <span className={classes.typeDetail}>
                  {tooltipInfo.nextBestAction}
                </span>
              </div>
            </div>
          </div>
        </DialogContent>
      </Dialog>
    </div>
  )
}

export default React.memo(ChartTooltipModal)
